(function () {
  function initCarousel(root) {
    var slider = root.querySelector('.slider');
    var prevButton = root.querySelector('.slider-button--prev');
    var nextButton = root.querySelector('.slider-button--next');
    var status = root.querySelector('.slider-status');

    if (!slider || !prevButton || !nextButton) return;

    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && slider.children.length > 1;
    var speed = parseFloat(root.getAttribute('data-speed')) || 2.5;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplayTimer = null;
    var initialStartTimer = null;
    var initialDelayPending = true;
    var hovering = false;
    var focusedInside = false;
    var originalCount = slider.children.length;
    var bufferSets = 2;
    var loopWidth = 0;
    var anchorScroll = 0;
    var queue = [];
    var moving = false;
    var settleTimer = null;

    function cardWidth() {
      var firstSlide = slider.querySelector('.slider__slide');
      if (!firstSlide) return slider.clientWidth / 2;
      return firstSlide.getBoundingClientRect().width;
    }

    function gapWidth() {
      return parseFloat(getComputedStyle(slider).columnGap) || 0;
    }

    function cardStep() {
      return cardWidth() + gapWidth();
    }

    function measureLoopWidth() {
      var trailingFirst = slider.children[originalCount * (bufferSets + 1)];
      var middleFirst = slider.children[originalCount * bufferSets];
      if (trailingFirst && middleFirst) {
        return trailingFirst.getBoundingClientRect().left - middleFirst.getBoundingClientRect().left;
      }
      return originalCount * cardStep();
    }

    // The scroll offset that would place `el` in the horizontal centre of the
    // slider's viewport.
    function centerScrollOf(el) {
      return (
        slider.scrollLeft +
        el.getBoundingClientRect().left -
        slider.getBoundingClientRect().width / 2 +
        el.getBoundingClientRect().width / 2
      );
    }

    function instantScrollTo(left) {
      slider.scrollLeft = left;
    }

    function smoothScrollBy(delta) {
      slider.scrollTo({ left: slider.scrollLeft + delta, behavior: 'smooth' });
    }

    // Status always reflects the original product set, never the clones that
    // double the DOM. The infinite index is reduced mod originalCount.
    function updateStatus() {
      if (!status || originalCount === 0) return;
      var first = slider.querySelector('.slider__slide');
      if (!first) return;
      var firstCenter = first.getBoundingClientRect().left + first.getBoundingClientRect().width / 2;
      var sliderCenter =
        slider.getBoundingClientRect().left + slider.getBoundingClientRect().width / 2;
      var infiniteIndex = Math.round((sliderCenter - firstCenter) / cardStep());
      var product = ((infiniteIndex % originalCount) + originalCount) % originalCount;
      status.textContent = 'Slide ' + (product + 1) + ' of ' + originalCount;
    }

    // Only after a full period has been traversed, snap back to the equivalent
    // frame by shifting the anchor scroll position once, so the wrap is
    // invisible. Do not wait for the real scroll edges.
    function normalizeIfNeeded() {
      if (loopWidth <= 0) return;
      var current = slider.scrollLeft;
      if (current - anchorScroll >= loopWidth) {
        instantScrollTo(current - loopWidth);
      } else if (anchorScroll - current >= loopWidth) {
        instantScrollTo(current + loopWidth);
      }
      updateStatus();
    }

    function enqueueMove(direction) {
      queue.push(direction);
      processQueue();
    }

    function processQueue() {
      if (moving || queue.length === 0) return;
      moving = true;
      var direction = queue.shift();
      stepOnce(direction);
    }

    // Advance exactly one card in the given direction by a single smooth scroll;
    // normalization happens on settle, never before the move.
    function stepOnce(direction) {
      smoothScrollBy(direction * cardStep());
      scheduleSettle();
    }

    // After a move (or any idle scroll) settles, normalize the full-period
    // wrap and let the next queued advance run. Re-armed on every scroll event
    // so drags and native snap also normalize once they come to rest.
    function scheduleSettle() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        normalizeIfNeeded();
        if (moving) {
          moving = false;
          processQueue();
        }
      }, 250);
    }

    function autoRotate() {
      enqueueMove(1);
    }

    function beginInterval() {
      initialDelayPending = false;
      autoplayTimer = setInterval(autoRotate, speed * 1000);
    }

    function start() {
      if (!autoplayEnabled || reducedMotion.matches) return;
      stop();

      if (initialDelayPending) {
        initialStartTimer = setTimeout(function () {
          initialStartTimer = null;
          beginInterval();
        }, 4000);
      } else {
        beginInterval();
      }
    }

    function stop() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (initialStartTimer) {
        clearTimeout(initialStartTimer);
        initialStartTimer = null;
      }
    }

    function maybeResume() {
      if (!hovering && !focusedInside) start();
    }

    if (originalCount > 1) {
      var originals = Array.prototype.slice.call(slider.children);
      var firstOriginal = slider.children[0];

      function makeClone(slide) {
        var clone = slide.cloneNode(true);
        if (clone.id) clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        var focusables = clone.querySelectorAll('a[href], button, input, select, textarea, [tabindex], summary, iframe');
        focusables.forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      // Symmetric clone buffer: two sanitized clone sets prepended in original
      // order, the originals retained in the middle, and two sanitized clone
      // sets appended in original order.
      for (var set = 0; set < bufferSets; set += 1) {
        originals.forEach(function (slide) {
          slider.insertBefore(makeClone(slide), firstOriginal);
        });
      }
      for (var trailingSet = 0; trailingSet < bufferSets; trailingSet += 1) {
        originals.forEach(function (slide) {
          slider.appendChild(makeClone(slide));
        });
      }

      // The middle original product 1 is the initial centered anchor.
      var middleFirst = slider.children[originalCount * bufferSets];
      loopWidth = measureLoopWidth();

      // Compose the initial viewport: centre the middle original product 1 so
      // it sits at the visual centre with half-peek edge cards on both sides.
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      anchorScroll = Math.min(centerScrollOf(middleFirst), maxScroll);
      instantScrollTo(anchorScroll);
      updateStatus();

      slider.addEventListener('scroll', scheduleSettle, { passive: true });

      prevButton.addEventListener('click', function () {
        enqueueMove(-1);
      });
      nextButton.addEventListener('click', function () {
        enqueueMove(1);
      });

      if (autoplayEnabled) {
        root.addEventListener('mouseenter', function () {
          hovering = true;
          stop();
        });
        root.addEventListener('mouseleave', function () {
          hovering = false;
          maybeResume();
        });
        root.addEventListener('focusin', function () {
          focusedInside = true;
          stop();
        });
        root.addEventListener('focusout', function (event) {
          if (root.contains(event.relatedTarget)) return;
          focusedInside = false;
          maybeResume();
        });
        reducedMotion.addEventListener('change', function () {
          if (reducedMotion.matches) {
            stop();
          } else {
            maybeResume();
          }
        });
        start();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-new-arrivals]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
